import React from 'react';

interface BackspaceIconProps {
  width?: number;
  height?: number;
  stroke?: string;
  strokeWidth?: string;
}

const BackspaceIcon: React.FC<BackspaceIconProps> = ({
  width = 26,
  height = 26,
  stroke = 'currentColor',
  strokeWidth = '2',
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M10 5a2 2 0 0 0-1.344.519l-6.328 5.74a1 1 0 0 0 0 1.481l6.328 5.741A2 2 0 0 0 10 19h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2z" />
      <path d="m12 9 6 6" />
      <path d="m18 9-6 6" />
    </svg>
  );
};

export default BackspaceIcon;
